import { render, staticRenderFns } from "./SingleFlowLayoutSelector.vue?vue&type=template&id=01031c0a&scoped=true&"
import script from "./SingleFlowLayoutSelector.vue?vue&type=script&lang=ts&"
export * from "./SingleFlowLayoutSelector.vue?vue&type=script&lang=ts&"
import style0 from "./SingleFlowLayoutSelector.vue?vue&type=style&index=0&id=01031c0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01031c0a",
  null
  
)

export default component.exports